var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSync(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6563FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.223 11.483h-3.85c-.47 0-.85.381-.85.85 0 .47.38.85.85.85h2.04c-1.918 2.005-4.862 2.643-7.438 1.613C3.4 13.766 1.707 11.274 1.7 8.5c0-.47-.38-.85-.85-.85S0 8.03 0 8.5c.01 3.393 2.035 6.455 5.153 7.79 3.119 1.336 6.733.69 9.195-1.644v1.504c0 .47.38.85.85.85s.85-.38.85-.85v-3.825c-.004-.456-.368-.828-.824-.841zM8.5 0C6.32.006 4.227.85 2.652 2.354V.85c0-.47-.38-.85-.85-.85s-.85.38-.85.85v3.825c0 .47.38.85.85.85h3.825c.47 0 .85-.38.85-.85s-.38-.85-.85-.85h-2.04c1.917-2.003 4.858-2.642 7.434-1.614C13.596 3.239 15.289 5.727 15.3 8.5c0 .47.38.85.85.85s.85-.38.85-.85c0-2.254-.896-4.416-2.49-6.01C12.916.896 10.754 0 8.5 0z",
    transform: "translate(-312.000000, -282.000000) translate(39.000000, 253.000000) translate(26.000000, 27.000000) translate(247.000000, 2.000000)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.c2783721.svg";
export { ForwardRef as ReactComponent };